import { useEffect, useState } from "react";
import API from "../services/api";
import MainLayout from "../layouts/MainLayout";

export default function AssignManager() {
  const [managers, setManagers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedDealers, setSelectedDealers] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const users = await API.get("/dealer"); // dealers
    const resUsers = await API.get("/dealer"); // reuse if needed

    const allUsers = await API.get("/dealer"); // adjust if you have users API

    // 👉 Ideally you should have /users API
    const usersRes = await API.get("/dealer"); // TEMP (replace later)

    setDealers(users.data);

    // 🔥 TEMP MANAGER FILTER (replace with /users API)
    const managersData = [
      { id: 3, name: "Manager User" }
    ];

    setManagers(managersData);
  };

  const toggleDealer = (id) => {
    if (selectedDealers.includes(id)) {
      setSelectedDealers(selectedDealers.filter(d => d !== id));
    } else {
      setSelectedDealers([...selectedDealers, id]);
    }
  };

  const submit = async () => {
    if (!selectedManager || selectedDealers.length === 0) {
      return alert("Select manager & dealers");
    }

    await API.post("/admin/assign-manager", {
      manager_id: selectedManager,
      dealer_ids: selectedDealers
    });

    alert("Assigned successfully");
  };

  return (
    <MainLayout>
      <h2>Assign Manager</h2>

      {/* SELECT MANAGER */}
      <select
        onChange={(e) => setSelectedManager(e.target.value)}
        style={{ padding: 10, marginBottom: 20 }}
      >
        <option>Select Manager</option>
        {managers.map(m => (
          <option key={m.id} value={m.id}>
            {m.name}
          </option>
        ))}
      </select>

      {/* DEALERS LIST */}
      <div>
        <h3>Select Dealers</h3>
        {dealers.map(d => (
          <div key={d.id}>
            <input
              type="checkbox"
              onChange={() => toggleDealer(d.id)}
            />
            {d.dealer_name}
          </div>
        ))}
      </div>

      <button onClick={submit} style={{ marginTop: 20 }}>
        Save Assignment
      </button>
    </MainLayout>
  );
}